export default date => {
  if (date.seconds) {
    return new Date(date.seconds * 1000 + date.nanoseconds / 1000000);
  }
  return new Date(date._seconds * 1000 + date._nanoseconds / 1000000);
};
